import { ThemeUICSSObject } from '@apia/theme';
import { modulesTree } from './modulesTree';
/* IMPORT HERE */

export const functionalities: ThemeUICSSObject = {
  modulesTree,
  /* PREPEND HERE */
};
